import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptor } from "src/utils/baseQuery";

export const InventoryApi = createApi({
  reducerPath: "InventoryApi",
  baseQuery: baseQueryWithInterceptor,
  tagTypes: ["Inventory"],
  endpoints: (builder) => ({
    getInventoryList: builder.query<any, void>({
      query: () => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `inventory`,
        method: "GET",
      }),
    }),
    getLocksList: builder.query<
      any,
      {
        page: number;
        limit: number;
        imei?: string;
        allocatedTo?: string;
        notAllocatedTo?: string;
      }
    >({
      query: (params) => {
        let url = `inventory/last-location?limit=${params.limit}&page=${params.page}`;

        if (params.imei) {
          url += `&imei=${params.imei}`;
        }

        if (params.allocatedTo) {
          url += `&allocatedTo=${params.allocatedTo}`;
        }

        if (params.notAllocatedTo) {
          url += `&notAllocatedTo=${params.notAllocatedTo}`;
        }

        return {
          headers: {
            "Content-type": "application/json",
          },
          url: url,
          method: "GET",
        };
      },
    }),

    getInventoryAvailability: builder.mutation<any, string>({
      query: (imei) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `inventory/${imei}/availability`,
        method: "GET",
      }),
    }),
    getInventoryBattery: builder.query<any, string>({
      query: (lock) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `inventory/${lock}/battery`,
        method: "GET",
      }),
    }),
    unlockLock: builder.mutation<string, any>({
      query: (imei) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `order/unlock/${imei}`,
        method: "PATCH",
      }),
    }),
    supportUnlockLock: builder.mutation<string, any>({
      query: (imei) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `inventory/${imei}/sms`,
        method: "POST",
      }),
    }),
    getInventoryDailyData: builder.query<any, void>({
      query: () => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `inventory/daily-data`,
        method: "GET",
      }),
    }),
    getInventoryHub: builder.query<any, void>({
      query: () => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `inventory/hub`,
        method: "GET",
      }),
    }),
    getInventoryOrder: builder.query<any, void>({
      query: () => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `inventory-order`,
        method: "GET",
      }),
    }),
    getInventoryOrderByPort: builder.query<any, { portId: string | null }>({
      query: ({ portId }) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `inventory-order?hub=${portId}`,
        method: "GET",
      }),
    }),
    createInventoryOrder: builder.mutation<any, any>({
      query: (hub) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `inventory-order`,
        method: "POST",
        body: hub,
      }),
    }),
    updateInventoryOrder: builder.mutation<any, { orderId: string; status: string }>({
      query: ({ orderId, status }) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `inventory-order/${orderId}`,
        method: "PATCH",
        body: { status },
      }),
    }),
  }),
});

export const {
  useGetInventoryListQuery,
  useGetLocksListQuery,
  useGetInventoryAvailabilityMutation,
  useGetInventoryBatteryQuery,
  useUnlockLockMutation,
  useSupportUnlockLockMutation,
  useGetInventoryDailyDataQuery,
  useGetInventoryHubQuery,
  useGetInventoryOrderQuery,
  useCreateInventoryOrderMutation,
  useUpdateInventoryOrderMutation,
  useGetInventoryOrderByPortQuery
} = InventoryApi;
